import http from './request'
import { Toast, Dialog } from 'vant'

const CACHE_MS = 60000
let cached = null
let cachedAt = 0

export async function fetchShareConfigPublic(force) {
  if (!force && cached && Date.now() - cachedAt < CACHE_MS) {
    return cached
  }
  try {
    const res = await http.get('/api/share/config')
    if (res.data && res.data.code === 200 && res.data.data) {
      cached = res.data.data
      cachedAt = Date.now()
      return cached
    }
  } catch (e) {
    console.error(e)
  }
  cached = { enabled: false }
  cachedAt = Date.now()
  return cached
}

export function buildH5ShareLink(h5Path) {
  let p = (h5Path && String(h5Path).trim()) || '/home'
  if (!p.startsWith('/')) {
    p = '/' + p
  }
  const base = window.location.href.replace(/#.*$/, '')
  return base + '#' + p
}

export function isShareInviteEnabled(cfg) {
  return cfg && cfg.enabled === true
}

export async function inviteShareFriends(options) {
  options = options || {}
  const cfg = await fetchShareConfigPublic(!!options.force)
  if (!cfg.enabled) {
    Toast('分享功能暂未开放')
    return
  }
  const url = buildH5ShareLink(cfg.h5_path || '/home')
  const title = cfg.title || '邀请你来玩'

  if (typeof navigator !== 'undefined' && navigator.share) {
    try {
      await navigator.share({ title, text: title, url })
      return
    } catch (e) {
      if (e && e.name === 'AbortError') {
        return
      }
    }
  }

  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(url)
      Toast({
        message: '链接已复制。在微信内还可通过右上角「···」转发；小程序内转发会使用后台配置的标题与封面。',
        duration: 4200
      })
      return
    }
  } catch (e) {
    console.error(e)
  }

  Dialog.alert({
    title: '复制链接',
    message: url,
    confirmButtonText: '知道了'
  })
}
